import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment/environment';
import { Shape, ShapeCreateUpdate } from '@app/pipelines/models/shape';
import { PipelineReportsFilter } from '@app/pipelines/models/pipeline-reports-filter';
import { SurveyPipesheetData } from '@app/pipelines/models/pipeline-reports-pipesheet-chart-data';

@Injectable({
  providedIn: 'root'
})
export class ShapesService {
  readonly url = environment.api + 'pipesheetShapes';
  readonly elementUrl = environment.api + 'elements';
  readonly shapeEventUrl = environment.api + 'pipelinePipesheetReportFilter';
  readonly pipelineUrl = environment.api + 'pipeline';

  private readonly httpClient = inject(HttpClient);

  getAll(): Observable<Shape[]> {
    const requestUrl = `${this.url}`;
    return this.httpClient.get<Shape[]>(requestUrl);
  }

  getPipelinePipesheetShapesByPipelineId(pipelineId: number): Observable<Shape[]> {
    const requestUrl = `${this.pipelineUrl}/${pipelineId}/pipesheetShapes`;
    return this.httpClient.get<Shape[]>(requestUrl);
  }

  getById(shapeId: number): Observable<Shape> {
    const requestUrl = `${this.url}/${shapeId}`;
    return this.httpClient.get<Shape>(requestUrl);
  }

  post(data: ShapeCreateUpdate): Observable<Shape> {
    return this.httpClient.post<Shape>(this.url, data);
  }

  update(data: ShapeCreateUpdate, shapeId: number): Observable<Shape> {
    const requestUrl = `${this.url}/${shapeId}`;
    return this.httpClient.put<Shape>(requestUrl, data);
  }

  delete(id: number): Observable<Shape> {
    const requestUrl = `${this.url}/${id}`;
    return this.httpClient.delete<Shape>(requestUrl);
  }

  getPipelinePipesheetEventData(filterData: PipelineReportsFilter): Observable<SurveyPipesheetData[]> {
    const requestUrl = `${this.shapeEventUrl}`;
    return this.httpClient.post<SurveyPipesheetData[]>(requestUrl, filterData);
  }
}
